import { capitalize } from '@ember/string';
import Component from '@glimmer/component';
import type Patient from 'parog-web/models/patient';
import { modifier } from 'ember-modifier';
import type { Signature as BaseCancerFormSignature } from '../base-cancer-form';
import BaseCancerForm from '../base-cancer-form';
import t from 'ember-intl/helpers/t';

export interface Signature {
  Args: {
    BasicRadioGroup?: unknown;
    form: BaseCancerFormSignature['Args']['form'];
    patient: Patient;
  };
}

export default class MedicalHistoryFormBreastCancerDiagnosticFieldsComponent extends Component<Signature> {
  BaseCancerForm = BaseCancerForm;
  capitalize = capitalize;

  disableMetastaticField = modifier(function (e: HTMLElement): void {
    e.querySelector(
      '.ui.dropdown[data-test-dropdown="tnmClassification.m"]'
    )?.classList.add('disabled');
  });

  <template>
    <this.BaseCancerForm
      @form={{@form}}
      @patient={{@patient}}
      {{this.disableMetastaticField}}
    >
      <:content>
        <div class='field'>
          <@form.BasicRadioGroup @title='Côté' @propertyName='side' as |Group|>
            <div class='fields inline'>
              <div class='field'>
                <Group.Radio
                  @label={{this.capitalize
                    (t 'fur.cancer-medical-history.side' key='left')
                  }}
                  @value='left'
                />
              </div>
              <div class='field'>
                <Group.Radio
                  @label={{this.capitalize
                    (t 'fur.cancer-medical-history.side' key='right')
                  }}
                  @value='right'
                />
              </div>
              <div class='field'>
                <Group.Radio
                  @label={{this.capitalize
                    (t 'fur.cancer-medical-history.side' key='bilateral')
                  }}
                  @value='bilateral'
                />
              </div>
            </div>
          </@form.BasicRadioGroup>
        </div>
      </:content>
    </this.BaseCancerForm>
  </template>
}
